var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiocheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 30.043C25.5466 30.043 30.043 25.5466 30.043 20C30.043 14.4534 25.5466 9.95703 20 9.95703C14.4534 9.95703 9.95703 14.4534 9.95703 20C9.95703 25.5466 14.4534 30.043 20 30.043ZM20 32.043C26.6511 32.043 32.043 26.6511 32.043 20C32.043 13.3489 26.6511 7.95703 20 7.95703C13.3489 7.95703 7.95703 13.3489 7.95703 20C7.95703 26.6511 13.3489 32.043 20 32.043Z",
    fill: "#00AE80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.768 22.9735C15.4205 23.321 15.4205 23.8845 15.768 24.232C16.1155 24.5795 16.679 24.5795 17.0265 24.232L20 21.2585L22.9735 24.232C23.321 24.5795 23.8845 24.5795 24.232 24.232C24.5795 23.8845 24.5795 23.321 24.232 22.9735L21.2585 20L24.232 17.0265C24.5795 16.679 24.5795 16.1155 24.232 15.768C23.8845 15.4205 23.321 15.4205 22.9735 15.768L20 18.7415L17.0265 15.768C16.679 15.4205 16.1156 15.4205 15.768 15.768C15.4205 16.1155 15.4205 16.679 15.768 17.0265L18.7415 20L15.768 22.9735Z",
    fill: "#00AE80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiocheck);
export default __webpack_public_path__ + "static/media/radiocheck.386457086754172e20fc2536f052159d.svg";
export { ForwardRef as ReactComponent };